/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIFeedbackEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


export function instanceOfAPIFeedbackEnum(value: any): boolean {
    for (const key in APIFeedbackEnum) {
        if (Object.prototype.hasOwnProperty.call(APIFeedbackEnum, key)) {
            if (APIFeedbackEnum[key as keyof typeof APIFeedbackEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIFeedbackEnumFromJSON(json: any): APIFeedbackEnum {
    return APIFeedbackEnumFromJSONTyped(json, false);
}

export function APIFeedbackEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackEnum {
    return json as APIFeedbackEnum;
}

export function APIFeedbackEnumToJSON(value?: APIFeedbackEnum | null): any {
    return value as any;
}

